import React from 'react';
import { IspmCategoryWidget } from './widgets/IspmCategoryWidget';
import { IspmRiskLevelWidget } from './widgets/IspmRiskLevelWidget';
import IspmTopListsWidget from './widgets/IspmTopListsWidget';

const IspmDashboard = () => {
    return (
        <section className="flex flex-none gap-4 w-full h-52">
            <IspmCategoryWidget />
            <IspmRiskLevelWidget />
            <IspmTopListsWidget />
        </section>
    );
};

export default IspmDashboard;
